import React from 'react';
import type { GlossaryModalProps } from './types';
import {
  GLOSSARY_TAB_INACCURATE,
  GLOSSARY_TAB_CANCELLED,
  GLOSSARY_TAB_ONLINE_RATE,
  GLOSSARY_INACCURATE_INTRO,
  GLOSSARY_INACCURATE_RATE,
  GLOSSARY_ITEMS_MISSING,
  GLOSSARY_MISSING_CUSTOMIZATIONS,
  GLOSSARY_WRONG_ORDER,
  GLOSSARY_CANCELLED_INTRO,
  GLOSSARY_UNFULFILLED_RATE,
  GLOSSARY_UNACCEPTED,
  GLOSSARY_CANCELLED,
  GLOSSARY_ONLINE_RATE,
} from './constants';
import {
  StyledModal,
  ModalFooterWrap,
  DoneButton,
  StyledTabs,
  GlossaryParagraph,
  GlossaryHeading,
} from './styles';

const GlossaryModal: React.FC<GlossaryModalProps> = ({ open, onClose }) => {
  const tabItems = [
    {
      key: GLOSSARY_TAB_INACCURATE,
      label: 'Inaccurate orders',
      children: (
        <>
          <GlossaryParagraph>{GLOSSARY_INACCURATE_INTRO}</GlossaryParagraph>
          <GlossaryHeading>Inaccurate orders rate</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_INACCURATE_RATE}</GlossaryParagraph>
          <GlossaryHeading>Items missing</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_ITEMS_MISSING}</GlossaryParagraph>
          <GlossaryHeading>Missing customizations</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_MISSING_CUSTOMIZATIONS}</GlossaryParagraph>
          <GlossaryHeading>Wrong order delivered</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_WRONG_ORDER}</GlossaryParagraph>
        </>
      ),
    },
    {
      key: GLOSSARY_TAB_CANCELLED,
      label: 'Cancelled orders',
      children: (
        <>
          <GlossaryParagraph>{GLOSSARY_CANCELLED_INTRO}</GlossaryParagraph>
          <GlossaryHeading>Unfulfilled order rate</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_UNFULFILLED_RATE}</GlossaryParagraph>
          <GlossaryHeading>Unaccepted (timed out)</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_UNACCEPTED}</GlossaryParagraph>
          <GlossaryHeading>Cancelled</GlossaryHeading>
          <GlossaryParagraph>{GLOSSARY_CANCELLED}</GlossaryParagraph>
        </>
      ),
    },
    {
      key: GLOSSARY_TAB_ONLINE_RATE,
      label: 'Online rate',
      children: <GlossaryParagraph>{GLOSSARY_ONLINE_RATE}</GlossaryParagraph>,
    },
  ];

  return (
    <StyledModal
      title="Operations glossary"
      open={open}
      onCancel={onClose}
      footer={
        <ModalFooterWrap>
          <DoneButton type="primary" onClick={onClose}>
            Done
          </DoneButton>
        </ModalFooterWrap>
      }
      width={520}
      destroyOnClose
    >
      <StyledTabs defaultActiveKey={GLOSSARY_TAB_INACCURATE} items={tabItems} />
    </StyledModal>
  );
};

export default React.memo(GlossaryModal);
